import * as DialogPrimitive from "@radix-ui/react-dialog";

/**
 * Dialog Trigger Component
 * Wrapper for Radix UI Dialog Trigger
 */
export const DialogTrigger = DialogPrimitive.Trigger;

